import * as React from 'react';
import styled from 'styled-components';
import { alignOptions } from './RemoteTable.types';

const StyledRow = styled.td`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: no-wrap:
`;

interface IRowCellProps {
  value: string | React.ReactNode;
  rowStyle?: object;
  align: alignOptions;
}

const RowCell: React.FC<IRowCellProps> = (props: IRowCellProps) => {
  const { value, align, rowStyle } = props;
  return (
    <StyledRow style={rowStyle} align={align}>
      {value}
    </StyledRow>
  );
};

export default RowCell;
